import XButton2 from "components/common/button/XButton2";
import { CategoryModel } from "models";
import React, { useEffect } from "react";
import CategoryCorpForm from "./CategoryCorpForm";
import { Utils } from "utils";

type PROPS = {
  category: CategoryModel[];
  data: {
    corp_large_category_id?: string;
    corp_medium_category_id?: string;
  }[];
};

const CategoryCorpForms: React.FC<PROPS> = (props) => {
  const [data, setData] = React.useState<
    {
      corp_large_category_id?: string;
      corp_medium_category_id?: string;
    }[]
  >([]);

  const onAddItem = () => {
    props.data.push({
      corp_large_category_id: Utils.randomStr(8),
    });
    setData([...props.data]);
  };
  const onRemoveItem = (index: number) => {
    props.data.splice(index, 1);
    setData([...props.data]);
  };

  useEffect(() => {
    setData([...props.data]);
  }, [props.data]);

  return (
    <div className="flex flex-col gap-2">
      {data.map((c, index) => {
        return (
          <div key={index} className="flex items-center flex-row-reverse gap-2">
            <div className={`category-action ${data.length <= 1 && "invisible"}`}>
              <XButton2
                action={() => {
                  onRemoveItem(index);
                }}
              />
            </div>
            <div className="flex-1 p-1 category-form border border-transparent">
              <CategoryCorpForm
                key={c.corp_large_category_id}
                category={props.category}
                options={c}
              />
            </div>
          </div>
        );
      })}
      <div className="flex justify-start">
        <button
          className="group border border-jhk-blue rounded hover:bg-gray-100 disabled:bg-gray-300 disabled:border-gray-400"
          disabled={data.length >= 5}
          onClick={onAddItem}
        >
          <div className="text-jhk-blue mx-3 my-1 group-disabled:text-gray-400">
            +
          </div>
        </button>
      </div>
    </div>
  );
};

export default CategoryCorpForms;
